module.exports = __webpack_public_path__ + "img/logo.8ecd00ec.svg";